export default "__VITE_ASSET__D5PnF4in__"